import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/from-azierta-to-qbd-group")({
  head: () => buildRouteHead("/en/from-azierta-to-qbd-group", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/about-qbd/story", replace: true });
  },
});
